var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Commitments")]),_c('Commitments',{ref:"commitments",on:{"refresh":_vm.refreshCommitments},model:{value:(_vm.form.commitments),callback:function ($$v) {_vm.$set(_vm.form, "commitments", $$v)},expression:"form.commitments"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }